export default "__VITE_ASSET__D3mvwnqv__"